import{__assign as e}from"../../node_modules/tslib/tslib.es6.js";import{j as o}from"../../node_modules/react/jsx-runtime.js";import r from"@jobseeker/feature-course/lib/components/CourseDetail";var s=function(s){return o.jsx(r,e({},s))};export{s as default};
//# sourceMappingURL=CourseDetail.js.map
